var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.inTranslateMode)?_c('div',{staticClass:"add-content-block-marker"},[_c('div',{staticClass:"inner-border"}),_c('i',{staticClass:"material-icons",on:{"click":function($event){return _vm.$emit('markerClicked')}}},[_vm._v("add")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }